import TabIngles from './TabIngles'

export default TabIngles
